import expenseReloadRawString from '../ExpenseReload.graphql'

export const expenseReloadString = expenseReloadRawString

export type ExpenseReload = {
  purchaseAmount: number
  threshold: number
  enabled: boolean
}

export const isExpenseReload = (fragment: any): fragment is ExpenseReload =>
  fragment &&
  typeof fragment.purchaseAmount === 'number' &&
  typeof fragment.threshold === 'number' &&
  typeof fragment.enabled === 'boolean'
